import { getAnnualReviewDetailUrl, getAnnualReviewEditUrl } from 'bank-annual-review/src/Routes/AnnualReview/route'
import { AnnualReview } from 'commons/types/DTO/bank/companyDetails/annualReview'
import { DateTime } from 'ui/components'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'

interface Columns {
  onDeleteReview: (review: AnnualReview) => void
  id: number
  showCompany?: boolean
  inAlerts?: boolean
}

export const columns = ({ onDeleteReview, id, inAlerts }: Columns): TableColumn<AnnualReview>[] => [
  {
    title: 'Annual Review Number',
    render: (item) => (
      <Link to="/annual-review/detail/$companyId/$id" params={{ companyId: id.toString(), id: item.id.toString() }}>
        {item.annualReviewNumber}
      </Link>
    )
  },
  {
    title: 'Financials Date',
    align: 'center',
    render: ({ financialsDate }) => <DateTime date={financialsDate} />
  },
  {
    title: 'Status',
    align: 'center',
    key: 'status'
  },
  {
    title: 'Date Completed',
    align: 'center',
    render: ({ dateCompleted }) => <DateTime date={dateCompleted} />
  },
  {
    title: 'Created Date',
    align: 'center',
    render: ({ createdDate }) => <DateTime date={createdDate} withTime />
  },
  {
    title: 'Action',
    align: 'center',
    width: '150px',
    render: (item) => (
      <TableActions
        items={[
          ...(item.status === 'New' || item.status === 'Incomplete'
            ? [
                {
                  type: 'option' as const,
                  title: item.status === 'Incomplete' ? 'Continue Review' : 'Start Review',
                  url: getAnnualReviewEditUrl({ id: item.id, companyId: id })
                }
              ]
            : []),
          ...(item.status === 'Completed'
            ? [
                {
                  type: 'option' as const,
                  title: 'Approve',
                  url: getAnnualReviewDetailUrl({ id: item.id, companyId: id })
                }
              ]
            : []),
          ...(item.status === 'Approved'
            ? [
                {
                  type: 'edit' as const,
                  url: getAnnualReviewEditUrl({ id: item.id, companyId: id })
                }
              ]
            : []),
          ...(!inAlerts
            ? [
                {
                  type: 'delete' as const,
                  onClick: () => onDeleteReview(item)
                }
              ]
            : [])
        ]}
      />
    )
  }
]
